
import {
  ConnectionListResult,
  FeatureFlagsContext,
  GridSortProps,
  PaginatedQueryWrapper
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import {
  TablesByTagQuery,
  TablesByTagQuery_tags_databaseTablesConnection_nodes,
  TablesByTagQueryVariables,
} from '../../../gen-src/queries/TablesByTagQuery';
import {
  TablesQuery,
  TablesQuery_databaseTablesConnection_nodes,
  TablesQueryVariables,
} from '../../../gen-src/queries/TablesQuery';
import { DatabaseTableSortOrder } from '../../../gen-src/queries/globalTypes';
import { TablesQueryGql } from '../../queries/TablesQueryGql';
import { TablesDisplayGrid } from '../sharedDisplayGrid/TablesDisplayGrid';
import { TablesValidSortFields } from '../sorting/sortProviders/TablesGridSortProvider';
import { getRowDataWithMaxCountsForTable } from '../table/functions/TableRowDataFunctions';
import { TablesDisplayGridRowData } from '../table/types/TablesDisplayGridRowData';

export type QueryVariables = TablesQueryVariables;
export type QueryResults = TablesQuery;
export type QueryResultListNode = TablesQuery_databaseTablesConnection_nodes;

export type QueryVariablesWithTagFilter = TablesByTagQueryVariables;
export type QueryResultsWithTagFilter = TablesByTagQuery;
export type QueryResultListNodeWithTagFilter = TablesByTagQuery_tags_databaseTablesConnection_nodes;

export type GridRowData = TablesDisplayGridRowData;

export function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.databaseTablesConnection;
}

export function selectConnectionListResultWithTagFilter(
  resultData: QueryResultsWithTagFilter
): ConnectionListResult<QueryResultListNodeWithTagFilter> | null {
  return resultData && resultData.tags && resultData.tags[0].databaseTablesConnection;
}

export type TablesExplorerQueryGridProps = GridSortProps<TablesValidSortFields>;

// This component is used only from the example. In the actual app, we render the Tables Explorer via VizPortal's "Explorer" instead,
// using these result mappers and the columns from the TablesDisplayGrid.
export function TablesExplorerQueryGrid(props: TablesExplorerQueryGridProps): JSX.Element {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={TablesQueryGql}
      partialQueryVariables={{
        orderBy: props.orderBy as DatabaseTableSortOrder,
        publishedConnectionsLineageEnabled
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataWithMaxCountsForTable}
    >
      {({ rowStore }) => (
        <TablesDisplayGrid
          rowStore={rowStore}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />
      )}
    </PaginatedQueryWrapper>
  );
}
